<template>
	<view class="order">
		<!-- <view class="order-quxiaole">
			已取消
		</view> -->
		<view class="order-head" :style="{ backgroundImage: 'url(' + bgImg + ')' }">
			<view class="order-head-status">待接单</view>
			<view class="order-head-info">您已经成功发起用工单，请耐心等待接单</view>
		</view>
		<view class="order-quxiao">
			<view class="order-quxiao-btn">取消订单</view>
		</view>
		<view class="order-user">
			<view class="order-user-info">
				<view class="user-info-l">
					<view class="user-info-l-image">
						<image src="/static/logo.png" mode="widthFix"></image>
					</view>
					<view class="user-info-l-i">
						<view class="user-info-l-i-top">莲花劳务公司</view>
						<view class="user-info-l-i-bottom">
							<view class="user-info-l-i-bottom-item">
								<text>评分：</text>
								<text>90</text>
							</view>
							<view class="user-info-l-i-bottom-item">
								<text>单数：</text>
								<text>100</text>
							</view>
						</view>
					</view>
				</view>
				<view class="user-info-r">
					<image src="/static/icon/ic_call@2x.png" mode="widthFix"></image>
					<text>联系师傅</text>
				</view>
			</view>
		</view>
		<view class="order-info">
			<view class="order-info-title">
				<view class="x"></view>
				<text>用工单-采摘工</text>
			</view>
			<view class="order-info-wz">葡萄｜2000斤</view>
			<view class="order-info-address">
				<image src="/static/icon/order_ic_location@2x.png" mode="widthFix"></image>
				<view class="order-info-address-info">
					<text>长江西路大蜀山森林公园西门保安室</text>
					<text>地点描述文字地点描述地点描述文字</text>
				</view>
			</view>
			<view class="order-info-address">
				<image src="/static/icon/order_ic_time@2x.png" mode="widthFix"></image>
				<view class="order-info-address-info">
					<text>长江西路大蜀山森林公园西门保安室</text>
				</view>
			</view>
			<view class="order-info-x"></view>
			<view class="order-info-supplement">
				<view class="order-info-supplement-title">需求补充：</view>
				<view class="order-info-supplement-val">男女都可，包午饭，干活麻利，早上9点到下午4点，可免费带1斤葡萄回家</view>
				<view class="order-info-supplement-list">
					<view class="order-info-supplement-list-item" v-for="(item,index) in 4" :key="index">
						<image src="/static/logo.png" mode="widthFix"></image>
					</view>
					<view style="width: 156rpx; height: 0;"></view>
					<view style="width: 156rpx; height: 0;"></view>
				</view>
			</view>
			<view class="order-info-price">
				<view class="price-row">
					<view class="price-row-label">费用标准</view>
					<view class="price-row-val">0.5元/斤</view>
				</view>
				<view class="price-row">
					<view class="price-row-label">预估总费用</view>
					<view class="price-row-val" style="color: #FF0000;">¥1000.00</view>
				</view>
			</view>
		</view>
		<view class="order-info">
			<view class="order-info-title">
				<text>评价</text>
			</view>
			<u-rate :count="count" activeColor="#FFC331" size="26" v-model="value"></u-rate>
			<view class="order-info-remark">
				干活利落效率高干活利落效率高干活利落效率高干活利落效率高干活利落效率高
			</view>
		</view>
		<view class="order-ren">
			<view class="order-ren-left">
				<view class="order-ren-left-img">
					<image src="/static/logo.png" mode="widthFix"></image>
				</view>
				<text>史天敏</text>
				<view class="order-ren-left-tip">业主</view>
			</view>
			<view class="order-ren-x"></view>
			<view class="order-ren-lx">
				<image src="/static/icon/ic_call@2x.png" mode="widthFix"></image>
				<text>联系业主</text>
			</view>
		</view>
		<view class="order-info">
			<view class="order-info-title">
				<text>订单信息</text>
			</view>
			<view class="order-info-list">
				<view class="order-info-list-item">
					<text>订单编号：</text>
					<text>202107131742520001</text>
				</view>
				<view class="order-info-list-item">
					<text>下单时间：</text>
					<text>2025-07-26 09:32:11</text>
				</view>
				<view class="order-info-list-item">
					<text>接单时间：</text>
					<text>2025-07-26 09:32:11</text>
				</view>
				<view class="order-info-list-item">
					<text>开始时间：</text>
					<text>2025-07-26 09:32:11</text>
				</view>
				<view class="order-info-list-item">
					<text>完成时间：</text>
					<text>2025-07-26 09:32:11</text>
				</view>
				<view class="order-info-list-item">
					<text>支付时间：</text>
					<text>2025-07-26 09:32:11</text>
				</view>
				<view class="order-info-list-item">
					<text>支付方式：</text>
					<text>2025-07-26 09:32:11</text>
				</view>
				<view class="order-info-list-item">
					<text>交易单号：</text>
					<text>2025-07-26 09:32:11</text>
				</view>
			</view>
		</view>
		<view style="width: 100%; height: calc(108rpx + env(safe-area-inset-bottom));"></view>
		<view class="order-footer">
			<view class="order-footer-btn">
				<view class="order-footer-btn-a" @click="show = true">取消订单</view>
				<view class="order-footer-btn-b">修改订单</view>
			</view>
			<view style="width: 100%; height: env(safe-area-inset-bottom);"></view>
		</view>
		
		<u-modal
			title="温馨提示"
			:show="show"
			closeOnClickOverlay
			showCancelButton
		>
			<view class="slot-content">
				确认取消订单吗？
			</view>
			<view slot="confirmButton" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
				<view class="btn1" @click="show = false">我再想想</view>
				<view class="btn2" @click="show = false">确认取消</view>
			</view>
		</u-modal>
		
		<!-- 支付弹窗 -->
		<u-popup :show="show1" round="15" mode="bottom">
			<view class="zhifu">
				<view class="zhifu-head">
					<view></view>
					<text>支付订单</text>
					<image @click="show1 = false" src="/static/icon/ic_close@2x.png" mode="widthFix"></image>
				</view>
				<view class="zhifu-c">
					<view class="zhifu-c-info">
						请确认金额并支付费用给 <text>莲花劳务公司</text>
					</view>
					<view class="zhifu-c-info1">支付金额：</view>
					<view class="zhifu-c-input">
						<image src="/static/icon/¥@2x.png" mode="widthFix"></image>
						<input type="number" placeholder="请输入" />
					</view>
				</view>
				<view class="zhifu-botton">确认支付</view>
			</view>
		</u-popup>
		
		<!-- 评价 -->
		<u-popup :show="show2" round="15" mode="bottom">
			<view class="zhifu">
				<view class="zhifu-head">
					<view></view>
					<text>评价</text>
					<image @click="show2 = false" src="/static/icon/ic_close@2x.png" mode="widthFix"></image>
				</view>
				<view class="zhifu-pj">
					<view class="zhifu-pj-label">服务评价</view>
					<view class="zhifu-pj-val">
						<u-rate :count="count" activeColor="#FFC331" size="26" v-model="value"></u-rate>
					</view>
				</view>
				<view class="zhifu-textarea">
					<image src="/static/icon/ic_pingjia@2x.png" mode="widthFix"></image>
					<u--textarea placeholder="请说说您对本次交易的感受" border="none" count></u--textarea>
				</view>
				<view class="zhifu-botton" style="margin-top: 60rpx;">立即评价</view>
			</view>
		</u-popup>
		
	</view>
</template>

<script>
	export default {
		data() {
			return {
				show: false,
				show1: false,
				show2: false,
				count: 4,
				value: 2,
				bgImg: require('@/static/image/bg_green@2x.png')
			};
		}
	}
</script>

<style>
	page {
		background-color: #F7F7F7;
	}
	.u-textarea__count {
		background-color: rgba(0, 0, 0, 0) !important;
	}
	.u-textarea {
		width: 100% !important;
		height: 100% !important;
		padding: 0 !important;
		background-color: rgba(0, 0, 0, 0) !important;
	}
	textarea {
		width: 100% !important;
		height: 100% !important;
	}
</style>

<style lang="scss" scoped>
	.order {
		width: 100%;
		.zhifu {
			width: 100%;
			padding: 40rpx 30rpx;
			box-sizing: border-box;
			.zhifu-textarea {
				width: 100%;
				height: 364rpx;
				padding: 30rpx;
				box-sizing: border-box;
				background: #F7F7F7;
				border-radius: 16rpx;
				border: 1rpx solid #EEEEEE;
				margin-top: 48rpx;
				display: flex;
				align-items: start;
				image {
					flex-shrink: 0;
					width: 29rpx;
					height: 29rpx;
					margin-right: 10rpx;
				}
			}
			.zhifu-pj {
				width: 100%;
				display: flex;
				align-items: center;
				margin-top: 40rpx;
				.zhifu-pj-label {
					flex-shrink: 0;
					margin-right: 40rpx;
				}
				.zhifu-pj-val {
					flex: 1;
					
				}
			}
			.zhifu-head {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				image {
					width: 28rpx;
					height: 28rpx;
				}
				text {
					font-weight: 500;
					font-size: 32rpx;
					color: #222222;
				}
			}
			.zhifu-c {
				width: 100%;
				margin-top: 46rpx;
				.zhifu-c-info {
					display: flex;
					align-items: center;
					font-weight: 500;
					font-size: 30rpx;
					color: #222222;
					margin-bottom: 30rpx;
					text {
						color: #00BC12;
						margin-left: 10rpx;
					}
				}
				.zhifu-c-info1 {
					font-weight: 400;
					font-size: 30rpx;
					color: #666666;
					margin-bottom: 20rpx;
				}
				.zhifu-c-input {
					width: 100%;
					padding: 0 30rpx;
					box-sizing: border-box;
					height: 112rpx;
					background: #F7F7F7;
					border-radius: 10rpx;
					border: 1rpx solid #EEEEEE;
					display: flex;
					align-items: center;
					image {
						flex-shrink: 0;
						width: 28rpx;
						height: 60rpx;
						margin-right: 24rpx;
					}
					input {
						flex: 1;
						height: 100%;
						font-weight: 500;
						font-size: 50rpx;
						color: #222222;
					}
				}
			}
			.zhifu-botton {
				width: 100%;
				height: 88rpx;
				line-height: 88rpx;
				text-align: center;
				font-weight: 500;
				font-size: 32rpx;
				color: #FFFFFF;
				background: #00BC12;
				border-radius: 44rpx;
				margin-top: 264rpx;
			}
		}
		.slot-content {
			width: 100%;
			text-align: center;
			font-weight: 400;
			font-size: 30rpx;
			color: #333333;
			margin: 30rpx 0;
		}
		.btn1 {
			width: 264rpx;
			height: 88rpx;
			line-height: 88rpx;
			text-align: center;
			font-weight: 400;
			font-size: 32rpx;
			color: #666666;
			border-radius: 44rpx;
			border: 1rpx solid #B2B2B2;
		}
		.btn2 {
			width: 264rpx;
			height: 88rpx;
			line-height: 88rpx;
			text-align: center;
			font-weight: 500;
			font-size: 32rpx;
			color: #FFFFFF;
			background: #00BC12;
			border-radius: 44rpx;
		}
		.order-footer {
			width: 100%;
			position: fixed;
			bottom: 0;
			left: 0;
			background-color: #ffffff;
			z-index: 9;
			height: calc(108rpx + env(safe-area-inset-bottom));
			.order-footer-btn {
				width: 100%;
				height: 108rpx;
				padding: 0 30rpx;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.order-footer-btn-a {
					width: 334rpx;
					height: 88rpx;
					line-height: 88rpx;
					text-align: center;
					font-weight: 500;
					font-size: 32rpx;
					color: #666666;
					border-radius: 44rpx;
					border: 1rpx solid #B2B2B2;
				}
				.order-footer-btn-b {
					width: 334rpx;
					height: 88rpx;
					line-height: 88rpx;
					text-align: center;
					font-weight: 500;
					font-size: 32rpx;
					color: #FFFFFF;
					background: #00BC12;
					border-radius: 44rpx;
				}
			}
		}
		.order-ren {
			width: 100%;
			height: 150rpx;
			background: #FFFFFF;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 30rpx;
			box-sizing: border-box;
			margin-bottom: 20rpx;
			.order-ren-left {
				display: flex;
				align-items: center;
				flex: 1;
				.order-ren-left-img {
					width: 80rpx;
					height: 80rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					overflow: hidden;
					border-radius: 50%;
					margin-right: 15rpx;
					image {
						width: 100%;
					}
				}
				text {
					font-weight: 400;
					font-size: 30rpx;
					color: #222222;
					margin-right: 15rpx;
				}
				.order-ren-left-tip {
					padding: 4rpx 12rpx;
					border-radius: 8rpx;
					border: 2rpx solid #FD9E24;
					font-weight: 400;
					font-size: 24rpx;
					color: #FF7200;
				}
			}
			.order-ren-x {
				width: 1rpx;
				height: 90rpx;
				margin-right: 50rpx;
				background-color: #E5E5E5;
			}
			.order-ren-lx {
				flex-shrink: 0;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				image {
					width: 34rpx;
					height: 34rpx;
				}
				text {
					font-weight: 400;
					font-size: 26rpx;
					color: #222222;
				}
			}
		}
		.order-info {
			width: 100%;
			padding: 30rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			margin-bottom: 20rpx;
			&:last-child {
				margin: 0 !important;
			}
			.order-info-list {
				width: 100%;
				.order-info-list-item {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-bottom: 30rpx;
					&:last-child {
						margin: 0 !important;
					}
					text {
						font-weight: 400;
						font-size: 26rpx;
						color: #777777;
					}
				}
			}
			.order-info-remark {
				font-weight: 400;
				font-size: 28rpx;
				color: #333333;
				margin-top: 36rpx;
			}
			.order-info-title {
				width: 100%;
				display: flex;
				align-items: center;
				margin-bottom: 20rpx;
				.x {
					width: 6rpx;
					height: 30rpx;
					background: #00BC12;
					border-radius: 4rpx;
					margin-right: 20rpx;
				}
				text {
					font-weight: 600;
					font-size: 32rpx;
					color: #222222;
				}
			}
			.order-info-wz {
				font-weight: 400;
				font-size: 28rpx;
				color: #888888;
				margin-bottom: 30rpx;
			}
			.order-info-x {
				width: 100%;
				height: 1rpx;
				margin: 20rpx 0 30rpx 0;
				background-color: #E5E5E5;
			}
			.order-info-price {
				width: 100%;
				display: flex;
				flex-direction: column;
				.price-row {
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-bottom: 30rpx;
					&:last-child {
						margin: 0 !important;
					}
					.price-row-label {
						font-weight: 400;
						font-size: 30rpx;
						color: #777777;
					}
					.price-row-val {
						font-weight: 500;
						font-size: 30rpx;
						color: #222222;
					}
				}
			}
			.order-info-supplement {
				width: 100%;
				margin-bottom: 40rpx;
				.order-info-supplement-title {
					font-weight: 600;
					font-size: 30rpx;
					color: #222222;
					margin-bottom: 16rpx;
				}
				.order-info-supplement-val {
					font-weight: 400;
					font-size: 28rpx;
					color: #333333;
					margin-bottom: 20rpx;
				}
				.order-info-supplement-list {
					width: 100%;
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					justify-content: space-between;
					.order-info-supplement-list-item {
						width: 156rpx;
						height: 156rpx;
						display: flex;
						align-items: center;
						justify-content: center;
						border-radius: 8rpx;
						overflow: hidden;
						image {
							width: 100%;
						}
					}
				}
			}
			.order-info-address {
				width: 100%;
				display: flex;
				align-items: start;
				margin-bottom: 20rpx;
				image {
					width: 28rpx;
					height: 28rpx;
					flex-shrink: 0;
					margin-right: 18rpx;
				}
				.order-info-address-info {
					flex: 1;
					display: flex;
					flex-direction: column;
					text {
						&:nth-child(1) {
							font-weight: 400;
							font-size: 28rpx;
							color: #222222;
						}
						&:nth-child(2) {
							font-weight: 400;
							font-size: 26rpx;
							color: #999999;
							margin-top: 16rpx;
						}
					}
				}
			}
		}
		.order-quxiaole {
			padding: 20rpx 0;
			box-sizing: border-box;
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			font-weight: 600;
			font-size: 40rpx;
			color: #111111;
			background-color: #ffffff;
		}
		.order-head {
			width: 100%;
			height: 172rpx;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			.order-head-status {
				font-weight: 600;
				font-size: 40rpx;
				color: #111111;
			}
			.order-head-info {
				font-weight: 400;
				font-size: 26rpx;
				color: #777777;
				margin-top: 18rpx;
			}
		}
		.order-user {
			width: 100%;
			padding: 30rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			.order-user-info {
				width: 100%;
				height: 150rpx;
				padding: 0 30rpx;
				box-sizing: border-box;
				background: #F7F8F5;
				border-radius: 16rpx;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.user-info-l {
					flex: 1;
					display: flex;
					align-items: center;
					.user-info-l-image {
						flex-shrink: 0;
						width: 80rpx;
						height: 80rpx;
						border-radius: 50%;
						overflow: hidden;
						display: flex;
						align-items: center;
						justify-content: center;
						margin-right: 20rpx;
						image {
							width: 100%;
						}
					}
					.user-info-l-i {
						flex: 1;
						height: 100%;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						.user-info-l-i-top {
							font-weight: 400;
							font-size: 30rpx;
							color: #222222;
						}
						.user-info-l-i-bottom {
							display: flex;
							align-items: center;
							margin-top: 14rpx;
							.user-info-l-i-bottom-item {
								display: flex;
								align-items: center;
								margin-right: 60rpx;
								&:last-child {
									margin: 0 !important;
								}
								text {
									&:nth-child(1) {
										font-weight: 400;
										font-size: 24rpx;
										color: #777777;
									}
									&:nth-child(2) {
										font-weight: 400;
										font-size: 24rpx;
										color: #222222;
									}
								}
							}
						}
					}
				}
				.user-info-r {
					flex-shrink: 0;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					image {
						width: 33rpx;
						height: 33rpx;
					}
					text {
						font-weight: 400;
						font-size: 26rpx;
						color: #222222;
						margin-top: 12rpx;
					}
				}
			}
		}
		.order-quxiao {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: #ffffff;
			.order-quxiao-btn {
				width: 160rpx;
				height: 64rpx;
				line-height: 64rpx;
				text-align: center;
				font-weight: 400;
				font-size: 28rpx;
				color: #666666;
				border-radius: 34rpx;
				border: 1rpx solid #B2B2B2;
			}
		}
	}
</style>
